export default "__VITE_ASSET__94b822d0__"